import React from "react";
import FromToRangeInput from "../../input/FromToRangeInput";
import { updateFilter } from "../../../store/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";

const Measurement = () => {
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  return (
    <div className="custom-tab mt-3">
      <div className="tab-idicator">
        <div className={`tab-item active`}>Measurement</div>
      </div>
      {/* <div className="mt-3 d-flex gap-3">
        <FromToRangeInput
          mainLabel={"Length"}
          mainContainerClass="w-100"
          innerContainerClass={"w-100"}
          fromValue={filterSelect?.minLangth}
          toValue={filterSelect?.maxLangth}
          onMinChange={(e) =>
            dispatch(
              updateFilter({ key: "minLangth", value: Number(e.target.value) })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({ key: "maxLangth", value: Number(e.target.value) })
            )
          }
        />
        <FromToRangeInput
          mainLabel={"width"}
          mainContainerClass="w-100"
          innerContainerClass={"w-100"}
          fromValue={filterSelect?.minWidth}
          toValue={filterSelect?.maxWidth}
          onMinChange={(e) =>
            dispatch(
              updateFilter({ key: "minWidth", value: Number(e.target.value) })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({ key: "maxWidth", value: Number(e.target.value) })
            )
          }
        />
        <FromToRangeInput
          mainLabel={"Depth"}
          mainContainerClass="w-100"
          innerContainerClass={"w-100"}
          fromValue={filterSelect?.minDepth}
          toValue={filterSelect?.maxDepth}
          onMinChange={(e) =>
            dispatch(
              updateFilter({ key: "minDepth", value: Number(e.target.value) })
            )
          }
          onMaxChange={(e) =>
            dispatch(
              updateFilter({ key: "maxDepth", value: Number(e.target.value) })
            )
          }
        />
      </div> */}
    </div>
  );
};

export default Measurement;
